<div class="modal fade" :id="modalComponentId" tabindex="-1" role="dialog" :aria-labelledby="modalComponentId + 'Label'" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" :id="modalComponentId + 'Label'">{{modalHeading}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onModalCloseClick">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <loading-spinner :showSpinner="loading"></loading-spinner>
                <div v-if="!loading">
                    <div class="input-group pb-4" v-if="(!showSuccessMessage && !showErrorMessage) && companyShippingAddresses.length === 0">
                        <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="searchQuery">
                        <div class="input-group-append" @click="getSalesRepCustomers">
                    <span class="input-group-text" id="basic-addon1">
                        <i class="fas fa-search"></i>
                    </span>
                        </div>
                    </div>
                    <div class="pb-4 w-100" v-if="(!showSuccessMessage && !showErrorMessage) && companyShippingAddresses.length === 0">
                        <button class="btn btn-primary float-right" @click="getSalesRepCustomers">Search</button>
                    </div>
                    <div class="alert alert-success alert-dismissible fade show" role="alert" v-if="showSuccessMessage">
                        {{successMessage}}
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearMessageAlerts">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="showErrorMessage">
                        {{errorMessage}}
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearMessageAlerts">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <p v-if="(!showSuccessMessage && !showErrorMessage)">
                        Sales Rep: {{salesRep.firstName}} {{salesRep.lastName}}
                    </p>
                    <data-table v-if="(!showSuccessMessage && !showErrorMessage) && companyShippingAddresses.length === 0"
                                :headings="salesRepCustomersHeadings"
                                :data="salesRepCustomers"
                                :hasActions="true"
                                :hasCustomActionComponent="true"
                                :hasNoFilter="true"
                                :hasNoPaging="true">
                        <template #actionComponent="{ companyId, registeredCompanyName }">
                            <button class="btn btn-link" @click="onCompanySelectClick(companyId, registeredCompanyName)">
                                Select
                            </button>
                        </template>
                    </data-table>

                    <p v-if="(!showSuccessMessage && !showErrorMessage) && companyShippingAddresses.length > 0">
                        Customer: {{selectedCompany.registeredCompanyName}}
                    </p>
                    <div class="input-group pb-4" v-if="(!showSuccessMessage && !showErrorMessage) && companyShippingAddresses.length > 0">
                        <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="shippingAddressSearchQuery">
                        <div class="input-group-append" @click="getCompanyShippingAddressesAssignedToSalesRep">
                    <span class="input-group-text" id="basic-addon1">
                        <i class="fas fa-search"></i>
                    </span>
                        </div>
                    </div>
                    <div class="pb-4 w-100" v-if="(!showSuccessMessage && !showErrorMessage) && companyShippingAddresses.length > 0">
                        <button class="btn btn-primary float-right" @click="getCompanyShippingAddressesAssignedToSalesRep">Search</button>
                    </div>
                    <data-table v-if="(!showSuccessMessage && !showErrorMessage) && companyShippingAddresses.length > 0"
                                :headings="shippingAddressHeadings"
                                :data="companyShippingAddresses"
                                :hasActions="true"
                                :hasCustomActionComponent="true"
                                :hasNoFilter="true"
                                :hasNoPaging="true">
                        <template #actionComponent="{ companyAddressId, isAssigned }">
                            <input type="checkbox" :checked="isAssigned" @change="onShippingAddressSelect(companyAddressId)">
                        </template>
                    </data-table>
                    <button class="btn btn-primary" @click="onBackToCustomerSelectClick" v-if="(!showSuccessMessage && !showErrorMessage) && companyShippingAddresses.length > 0">
                        Back To Customer Select
                    </button>
                </div>
                
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" @click="onModalSaveClick" :disabled="loading" v-if="(!showSuccessMessage && !showErrorMessage) && companyShippingAddresses.length > 0">SAVE</button>
                <button type="button" class="btn btn-secondary" :disabled="loading" data-dismiss="modal" @click="onModalCloseClick" v-if="!showSuccessMessage && !showErrorMessage">CLOSE</button>
                <button type="button" class="btn btn-primary" :disabled="loading" v-if="showSuccessMessage || showErrorMessage" @click="onModalCloseClick">OK</button>
            </div>
        </div>
    </div>
</div>